<template>
    <div id="messages" style="transition-delay: 0s" class="h-100 d-flex flex-column p-2 pt-lg-0">
        <div class="row p-2 pt-0 p-lg-2 pt-lg-0" style="padding-top: 0px !important;">
            <div class="card text-left mb-4 col-12 p-0 m-0 ">
                <h4 class="card-header">Send Kudos!</h4>
                <div class="card-body p-3">
                    <form>
                        <transition-group name="slide-up">
                            <div v-if="!selectedUser" key="search" class="user-search-container">
                                <i class="fas fa-search"></i>
                                <input type="text" class="form-control user-search" value="" placeholder="Search by name" v-model="userSearch" v-debounce:300ms="searchUser" @keydown.enter.prevent="searchUser">
                                <transition name="slide-up">
                                    <section id="user-list" key="user-list" v-show="userSearch && userSearch.length >= 3">
                                        <ul class="list-group">
                                            <li href="#" class="list-group-item list-group-item-action" v-for="user in users" v-if="users" @click="selectUser(user)">{{ user.first_name }} {{ user.last_name }}</li>
                                        </ul>
                                    </section>
                                </transition>
                                <div class="alert alert-warning mt-4 mb-0" v-show="!userSearch || userSearch.length < 3">
                                    Let us know if a colleague or friend deserves recognition, a pick me up or even help by giving them Kudos!
                                </div>
                            </div>
                            <div v-else key="form">
                                <h5>Give <a class="badge badge-primary bg-primary" @click="selectedUser=null">{{ selectedUser.first_name }}</a> Kudos!</h5>
                                <textarea class="form-control" rows="6" v-model="message"></textarea>
                                <div class="alert alert-warning mt-4 font-italic">{{ meaning }}</div>
                                <div class="row">
                                    <div class="col-12 text-right">
                                        <button type="button" class="btn btn-primary" @click="sendKudos" :disabled="disableSend">Send</button>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                    </form>
                </div>
            </div>
        </div>

        <Kudos class="row flex-grow-1 p-2 p-lg-1" :user="user" limit="10"></Kudos>

    </div>

</template>

<script>
import axios from "axios";
import Kudos from "@/components/Kudos";

export default {
    name: 'Messages',
    components: {
        Kudos
    },
    props: [
        'user'
    ],
    data() {
        return {
            kudos: null,
            meaning: 'Derived from the Greek word "κῦδος", meaning "fame" and/or "glory".',
            users: null,
            selectedUser: null,
            userSearch: null,
            message: null,
            disableSend: false
        }
    },
    methods: {
        getUsers() {
            let self = this;
            axios.get("/api/org/" + self.user.org_id + "/users", {
                params: {
                    'type': '1'
                }
            }).then(response => {
                if (response.data && response.data.length !== '') {
                    let data = response.data.filter(function (item) {
                        return item['id'] != self.$session.get('id')
                    })
                    self.users = data;
                }
            });
        },
        searchUser() {
            let self = this;
            if (self.userSearch != '') {
                $("#user-list ul.list-group li").filter(function () {
                    $(this).toggle($(this).html().toLowerCase().indexOf(self.userSearch.toLowerCase()) > -1)
                });
            }
        },
        selectUser(user) {
            if (user != '') {
                this.selectedUser = user;
            }
        },
        sendKudos() {
            let self = this;
            if (self.selectedUser && self.message) {
                self.disableSend = true;
                let formData = new FormData();
                formData.append('sender_id', self.user.id);
                formData.append('user_id', self.selectedUser.id);
                formData.append('comment', self.message);
                axios.post("api/kudos/save", formData).then(response => {
                    if (response.data) {
                        self.showAlert({'type': 'success', 'title': '', 'message': 'Kudos sent to ' + self.selectedUser.first_name});
                        self.message = null;
                        self.selectedUser = null;
                        self.userSearch = null
                        self.disableSend = false;
                        self.setPage('Home');
                    }
                });
            }
        }
    },
    mounted() {
        let self = this;
        self.getUsers();
    },
    created() {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Messages.vue